import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-without-permission',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './without-permission.component.html',
  styleUrl: './without-permission.component.scss',
})
export class WithoutPermissionComponent {}
